import React from "react";
import { FinancialDocument } from "@common/types/financialDocument";
import { Button } from "@design-system/Button/Button";
import { ButtonWithLoader } from "@design-system/Button/ButtonWithLoader";
import { useDownloadFinancialDocumentFile } from "./useDownloadFinancialDocumentFile";
import styles from "./FinancialDocumentDetailsHeader.module.scss";
import { useFinancialDocumentDetailsContext } from "./financialDocumentDetails.context";
import { FinancialDocumentDetailsView } from "./usePathBasedFinancialDocumentDetailsView";

interface FinancialDocumentNoMatchesProps {
    financialDocument: FinancialDocument;
}

export const FinancialDocumentNoMatches: React.FC<
    FinancialDocumentNoMatchesProps
> = ({ financialDocument }) => {
    const { changeView } = useFinancialDocumentDetailsContext();
    const { download, isDownloading } =
        useDownloadFinancialDocumentFile(financialDocument);

    return (
        <>
            <p className="text-gray-700">
                If this is a receipt, find a transaction.
            </p>
            <footer className={styles.noMatchesActions}>
                <ButtonWithLoader
                    variant="primary"
                    size="md"
                    onClick={() => {
                        void download();
                    }}
                    loading={isDownloading}
                >
                    Download
                </ButtonWithLoader>
                <Button
                    variant="primary"
                    size="md"
                    onClick={() =>
                        changeView(FinancialDocumentDetailsView.MATCHING)
                    }
                    data-testid="financial-document-no-matches-find-transaction-button"
                >
                    Find a transaction
                </Button>
            </footer>
        </>
    );
};
